import { NgIf } from '@angular/common';
import { Component, inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';
import { ErrorNotificationComponent } from '@components/error-notification/error-notification.component';
import { ConsultationStatus } from '@enums/consultation-status';
import { environment } from '@environments/environment';
import { ConsultationRequestService } from '@services/consultation-request.service';
import { LoadingService } from '@services/loading.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-schedule-consultation',
  templateUrl: './schedule-consultation.component.html',
  styleUrls: ['../consultation-request/consultation-request.component.scss', './schedule-consultation.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [NgIf, ErrorNotificationComponent],
})
export class ScheduleConsultationComponent implements OnInit, OnDestroy {
  public scheduleUrl: SafeResourceUrl;
  public scheduleOnceId: string;
  public errorMessage: string;
  public patientPhone: string;

  private acRoute = inject(ActivatedRoute);
  private consultationRequestService = inject(ConsultationRequestService);
  private loadingService = inject(LoadingService);
  private titleService = inject(Title);
  private domSanitizer = inject(DomSanitizer);
  private consultationId: string;
  private orderId: string;
  private hash: string;
  private routeSubscription: Subscription;

  /**
   * Gets the brand-specific content for the schedule consultation request page.
   */
  public get scheduledConsultationContent(): any {
    return environment.titles.scheduledConsultationRequest;
  }

  public ngOnInit(): void {
    this.titleService.setTitle(environment.titles.consultationRequest);

    this.routeSubscription = this.acRoute.queryParams.subscribe({
      next: (params: Params) => {
        if (!params.scheduleOnceId || !params.order_id || !params.consultationId || !params.hash) {
          this.errorMessage = 'Invalid consultation data, please contact customer service.';
        }

        this.loadingService.toggleLoader(true);
        this.orderId = params.order_id;
        this.consultationId = params.consultationId;
        this.hash = params.hash;
        this.patientPhone = params.contact;
        this.consultationRequestValidation(params.scheduleOnceId);
      },
    });

    this.consultationRequestService.clearLastConsultationRequestData();
  }

  public ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
  }

  /**
   * This method validate if the consultation request was created and initialize OnceHub
   *
   * @param scheduleOnceId Schedule once id
   */
  private consultationRequestValidation(scheduleOnceId: string): void {
    //Validate if the order already has schedule a consultation
    this.consultationRequestService.getConsultationRequest(this.consultationId, this.orderId, this.hash).subscribe({
      next: (consultation) => {
        if (consultation.consultation_status === ConsultationStatus.Canceled) {
          this.loadingService.toggleLoader(false);
          this.errorMessage = `Consultation was canceled, please contact customer service.`;

          return;
        }

        this.scheduleOnceId = scheduleOnceId;
        this.scheduleUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(consultation.reschedule_url);
        this.loadingService.toggleLoader(false);
      },
      error: () => {
        this.errorMessage = 'Invalid consultation data, please contact customer service.';
        this.loadingService.toggleLoader(false);
      },
    });
  }
}
